
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setup/first-upload",
      function () {
        return require("private-next-pages/setup/first-upload.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/setup/first-upload"])
      });
    }
  